<template>
  <el-dialog title="编辑" :visible.sync="isVisible" width="800px" custom-class="pw-edit" :close-on-press-escape="false"
    :close-on-click-modal="false" :before-close="closeEditDialog">
    <div style="display: flex;align-items: center;margin-bottom: 10px;">
      <div>数据权限类型：</div>
      <rs-select v-model="value" placeholder="请选择" style="width: 200px;" @change="onselectionchange">
        <rs-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </rs-option>
      </rs-select>
    </div>
    <div class="per_container">
      <div class="per_con_left">
        <div class="per_con_title">未选</div>
        <div class="check_all">

        </div>
        <div class="tree">
          <el-tree :empty-text="emptyText" ref="treeLeft" :data="treeDataArr" :props="props" node-key="id" show-checkbox
            :filter-node-method="filterNodeLeft" @check-change="(a,b,c) => handleCheckChange(a,b,c,'left')"
            :default-expanded-keys="defaultExpandedKeys" />
        </div>
      </div>
      <div class="operation">
        <el-button type="primary" @click="toRight()">添加
          <i class="el-icon-d-arrow-right"></i>
        </el-button>
        <el-button type="primary" icon="el-icon-d-arrow-left" @click="toLeft()">删除</el-button>
      </div>
      <div class="per_con_right">
        <div class="per_con_title">已选</div>
        <div class="check_all">

        </div>
        <div class="tree">
          <el-tree :empty-text="emptyText" ref="treeRight" :data="treeDataArr" :props="props" node-key="id"
            show-checkbox :filter-node-method="filterNodeRight"
            @check-change="(a,b,c) => handleCheckChange(a,b,c,'right')" :default-expanded-keys="defaultExpandedKeys" />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeEditDialog" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submitEdit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      emptyText: {
        type: String,
        default: '',
      },
      treeData: [],
    },
    watch: {
      isVisible(val) {
        if (val) {
          this.$nextTick(() => {
            this.setTreeFilter();
            this.$refs.treeLeft.setCheckedKeys([]);
            this.$refs.treeRight.setCheckedKeys([]);
          });
        }
      },
      treeData: {
        handler(val) {
          this.treeDataArr = val;
          this.allParentKeys = this.treeDataArr.map((item) => {
            return item.id;
          });
          if (this.$refs.treeLeft && this.$refs.treeRight) {
            this.$nextTick(() => {
              this.setTreeFilter();
            });
          }
        },
        deep: true,
      },
    },
    data() {
      return {
        props: {
          label: "categoryName",
          children: 'childList'
        },
        isIndeterminateL: false,
        isIndeterminateR: false,
        checkAllLeft: false,
        checkAllRight: false,
        treeDataArr: [],
        checkedKeys: [],
        halfCheckedKeys: [],
        checkedNodes: [],
        config: {
          left: {
            isIndeterminate: false,
            checkAll: false,
            ref: "treeLeft",
          },
          right: {
            isIndeterminate: false,
            checkAll: false,
            ref: "treeRight",
          },
        },
        options: [{
          value: 1,
          label: '按业态'
        }, {
          value: 2,
          label: '按楼层'
        }],
        value: 2,
        defaultExpandedKeys: [4]
      };
    },

    methods: {
      onselectionchange(e) {
        if (this.value == 1) {
          this.defaultExpandedKeys = [-1]
        }
        if (this.value == 2) {
          this.defaultExpandedKeys = [4]
        }
        this.$emit('selectionChange', e)
      },
      closeEditDialog() {
        this.value = 2
        this.$emit("closePerEdit");
      },
      setTreeFilter() {
        this.$refs.treeLeft.filter();
        this.$refs.treeRight.filter();
      },
      toLeft() {
        this.checkedKeys = this.$refs.treeRight.getCheckedKeys();
        this.halfCheckedKeys = this.$refs.treeRight.getHalfCheckedKeys();
        this.settreeDataArr(this.treeDataArr, false);
        this.setTreeFilter();
        this.$refs.treeLeft.setCheckedKeys(this.checkedKeys);
        this.$refs.treeRight.setCheckedKeys([]);
      },
      toRight() {
        this.checkedKeys = this.$refs.treeLeft.getCheckedKeys();
        this.halfCheckedKeys = this.$refs.treeLeft.getHalfCheckedKeys();
        this.settreeDataArr(this.treeDataArr, true);
        this.setTreeFilter();
        this.$refs.treeRight.setCheckedKeys(this.checkedKeys);
        this.$refs.treeLeft.setCheckedKeys([]);
      },
      filterNodeLeft(value, data) {
        return (data.selectStatus == null || !data.selectStatus);
      },
      filterNodeRight(value, data) {
        return data.selectStatus;
      },
      // 递归设置数据选中状态
      settreeDataArr(tree, type) {
        const setTree = (treeDataArr) => {
          treeDataArr.forEach((item, index) => {
            if ( this.checkedKeys.includes(item.id)) {
              treeDataArr[index].selectStatus = type;
            }
            if (item.childList && item.childList.length) {
              setTree(item.childList);
              // 判断半选框是否需要移动
              if (this.halfCheckedKeys.includes(item.id)) {
                if (type) {
                  treeDataArr[index].selectStatus = type;
                } else {
                  const target = treeDataArr[index].childList.find((it) => {
                    return it.selectStatus;
                  });
                  if (!target) {
                    treeDataArr[index].selectStatus = type;
                  }
                }
              }
            }
          });
        };
        setTree(tree);
      },
      defaultNode() {},
      submitEdit() {
        this.value = 2
        this.$emit("submitEdit", {
          treeDataArr: this.treeDataArr,
          checkedKeys: this.checkedKeys,
          halfCheckedKeys: this.halfCheckedKeys
        });
      },
      // 勾选树结构时判断是否勾选上面的全选
      handleCheckChange(data, checked, indeterminate, type) {
        // console.log(checked, 'checkedcheckedcheckedchecked')
        // if(checked && data.categoryLevel <= 2 && type == 'left' && this.canEmit) {
        //   this.canEmit = false
        //   setTimeout(()=>{
        //       this.canEmit = true
        //   },2000)
        //  // 获取之前选中的节点
        //   const checkedKeys = this.$refs.treeLeft.getCheckedKeys();
        //   // 重新设置默认选中的节点
        //   this.defaultCheckedKeys = checkedKeys;
        //   this.$emit("nodeCheck", data)
        // }

        this.checkedNodes = this.$refs[this.config[type].ref].getCheckedNodes();
        const pIds = this.checkedNodes.filter((item) => {
          return !item.pId;
        });
        if (!pIds.length) {
          this.config[type].checkAll = false;
          this.config[type].isIndeterminate = false;
          return;
        }
        if (pIds.length === this.allParentKeys.length) {
          this.config[type].checkAll = true;
          this.config[type].isIndeterminate = false;
        } else {
          this.config[type].isIndeterminate = true;
          this.config[type].checkAll = false;
        }
      },
      // 全选
      handleCheckAll(value, type) {
        const keys = value ?
          this.treeDataArr.map((item) => {
            return item.id;
          }) :
          [];
        this.$refs[this.config[type].ref].setCheckedKeys(keys, false);
      },
    },
  };
</script>
<style lang="less" scoped>
  /deep/.per_container {
    display: flex;
    height: 500px;
    justify-content: space-between;
    align-items: center;

    .per_con_left,
    .per_con_right {
      width: 45%;
      height: 100%;
    }

    .operation {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;

      .el-button {
        margin-left: 0;
        margin-bottom: 10px;
      }
    }

    .per_con_title {
      height: 42px;
      line-height: 26px;
      border-radius: 8px 8px 0 0;
      padding: 8px;
      align-self: stretch;
      background: #f2f6f9;
      font-size: 16px;
      box-sizing: border-box;
      border: 1px solid #d8d8d8;
      font-weight: 700;
      text-align: left;
    }

    .check_all {
      height: 10px;
      // line-height: 42px;
      // padding: 0 5px;
      border: 1px solid #d8d8d8;
      border-top: none;
      border-bottom: none;
      // text-align: left;
    }

    .tree {
      height: calc(100% - 82px);
      border: 1px solid #d8d8d8;
      border-top: none;
      overflow-y: auto; // 纵向滚动条
      overflow-x: auto; // 横向滚动条，根据内容自动显示
      width: 317px;
    }
  }
</style>